/**
 * Line-clamp "read more" for Product additional info rows.
 */
(function () {
  function checkOverflow(root) {
    const body = root.querySelector('.r3nu-ppi__body--clamped');
    if (!body || root.classList.contains('is-expanded')) return;
    if (body.scrollHeight <= body.clientHeight + 2) {
      root.classList.add('r3nu-ppi__clamp--no-overflow');
    } else {
      root.classList.remove('r3nu-ppi__clamp--no-overflow');
    }
  }

  function bind(root) {
    if (root.hasAttribute('data-r3nu-ppi-js')) return;
    const body = root.querySelector('.r3nu-ppi__body--clamped');
    const btn = root.querySelector('[data-r3nu-ppi-toggle]');
    if (!body || !btn) return;
    root.setAttribute('data-r3nu-ppi-js', '');

    const more = btn.getAttribute('data-label-more') || btn.textContent;
    const less = btn.getAttribute('data-label-less') || 'Show less';

    checkOverflow(root);
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        checkOverflow(root);
      }).observe(body);
    } else {
      window.addEventListener('resize', function onResize() {
        checkOverflow(root);
      });
    }

    btn.addEventListener('click', function () {
      const expanded = root.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded);
      btn.textContent = expanded ? less : more;
      if (expanded) {
        root.classList.remove('r3nu-ppi__clamp--no-overflow');
      } else {
        checkOverflow(root);
      }
    });
  }

  function init(container) {
    (container || document).querySelectorAll('[data-r3nu-ppi-clamp-root]').forEach(function (el) {
      bind(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) init(event.target);
  });
})();
